export default function auth({ next, router }) {
    const session = localStorage.getItem('user_lab_profile') || sessionStorage.getItem('user_lab_profile')
    if (!session) {
      return router.push({ name: 'auth-login' });
    } else {
      const parsedSession = JSON.parse(session)
      console.log(parsedSession)
      if (parsedSession.role.id !== 5) {
        return router.push({ name: 'home' })
      }
    }
    return next();
  }